import { Chip } from '@mui/material';
import React from 'react';

import AboutUs from '../../components/AboutUs/AboutUs';
//components:
import AddedBefore from '../../components/AddedBefore/AddedBefore';
import Cooperate from '../../components/Cooperate/Cooperate';
import Player from '../../components/player/Player';
import Share from '../../components/share/Share';
import WatchNow from '../../components/WatchNow/WatchNow';
//styles:
import styles from '../../styles/ArticleDetails.module.scss';
import { useMobile } from '../../utils/useMobile';

const ArticleDetails = ({ data, videos, articles, banersData }) => {
  const article = data[0];
  const { isMobile } = useMobile();

  const filteredArticles = articles.filter(
    (articleEl) => articleEl.newsid !== article.newsid
  );
  const articleBaners = banersData.data?.find(
    (baner) => baner.site === 'artykul'
  );

  return (
    article && (
      <>
        <header className={styles.articleHeader}>
          {article.video_status !== '0' ? (
            <Player
              url={article.video}
              className={styles.articleVideo}
              width={'1440px'}
            />
          ) : (
            <div
              style={{
                backgroundImage: `url(${
                  article.image ? article.image : '/toyaCover.png'
                })`,
                backgroundPosition: `${article.image ? 'top' : 'center'}`,
              }}
              className={styles.articleImage}
            />
          )}
        </header>
        <div
          className={styles.wrapper}
          style={{ marginBottom: article.content.length > 1000 && '0' }}
        >
          <div className={styles.articleContainer}>
            <Chip
              label={article.category === 'regular' ? 'Wydarzenia' : 'Sport'}
              className={styles.label}
            />
            <h3 className={styles.articleTitle}>{article.title}</h3>
            <p className={styles.articleAuthor}>{article.author}</p>
            {article.content.length < 1000 && (
              <article className={styles.articleShort}>
                {article.content}
              </article>
            )}
          </div>
          {article.content.length < 1000 && <Share type={'primary'} />}
        </div>
        {article.content.length > 1000 ? (
          <div className={styles.longWrapper}>
            <div className={styles.articleLong}>
              <p className={styles.longText}>{article.content}</p>
              <Share type={'secondary'} />
            </div>
            <AddedBefore
              direction={'column'}
              articles={filteredArticles.slice(0, 3)}
              banersData={articleBaners}
            />
          </div>
        ) : isMobile ? (
          <AddedBefore
            direction={'column'}
            articles={filteredArticles.slice(0, 3)}
          />
        ) : (
          <AddedBefore
            direction={'row'}
            articles={filteredArticles.slice(0, 3)}
          />
        )}
        <WatchNow data={videos} />
        <Cooperate />
        <AboutUs />
      </>
    )
  );
};
export async function getServerSideProps(context) {
  const id = context.params.id;
  let statusCode = null;
  const response = await fetch(
    'https://webapi.toya.net.pl/v1/tvtoya/news?id=' + id,
    {
      method: 'GET',
      mode: 'cors',
      headers: { Authorization: 'Basic dHZ0b3lhOkFZVnVmVUFyR2Y3TWtFTnY=' },
    }
  );

  const data = await response.json();

  var handleError = function (err) {
    new Error(err ? err : 'Error');
  };

  const articlesRes = await fetch(
    'https://webapi.toya.net.pl/v1/tvtoya/news?limit=4',
    {
      method: 'GET',
      mode: 'cors',
      headers: { Authorization: 'Basic dHZ0b3lhOkFZVnVmVUFyR2Y3TWtFTnY=' },
    }
  ).catch(handleError());

  const articles = await articlesRes.json();

  const videosReq = await fetch(
    `https://webapi.toya.net.pl/v1/tvtoya/onDemand?grouped=1&limit=9`,
    {
      method: 'GET',
      mode: 'cors',
      headers: { Authorization: 'Basic dHZ0b3lhOkFZVnVmVUFyR2Y3TWtFTnY=' },
    }
  );

  const videosData = await videosReq.json();

  const bannersReq = await fetch(
    `https://webapi.toya.net.pl/v1/tvtoya/banners`,
    {
      method: 'GET',
      mode: 'cors',
      headers: { Authorization: 'Basic dHZ0b3lhOkFZVnVmVUFyR2Y3TWtFTnY=' },
    }
  );

  const banersData = await bannersReq.json();

  if (
    response.status !== 200 ||
    articlesRes.status !== 200 ||
    videosReq.status !== 200
  )
    statusCode = 400;

  return {
    props: {
      data: data?.data,
      articles: articles.data,
      videos: videosData.data,
      banersData,
    },
  };
}

export default ArticleDetails;
